/**
 * Onde cada Dashboard App aparece.
 *
 * A escolha e EXCLUSIVA: `show_in_navigation` true = item proprio na barra
 * lateral, false = aba dentro da conversa. Nunca os dois.
 *
 * Vive aqui, e nao em cada componente, porque a regra tem duas metades
 * complementares — a conversa mostra o complemento do que a barra lateral
 * mostra. Escritas separadas, elas divergem em silencio: bastaria alguem trocar
 * uma condicao por `=== false` e um app com o campo ausente sumiria dos dois
 * lugares sem erro nenhum.
 */

// Cross-review 2026-08-27: `Boolean('false')` e `Boolean('0')` sao TRUE em JS, e
// um comentario meu afirmava que o cast protegia contra payload em string. Nao
// protegia — protegia contra `1`/`0` numericos e mais nada, e mandaria para a
// barra lateral justamente o app que o valor dizia NAO mandar. Uma string so vale
// como verdadeira quando diz que e.
export const isSidebarApp = app => {
  const valor = app?.show_in_navigation;
  if (typeof valor === 'string') return valor === 'true' || valor === '1';

  return Boolean(valor);
};

export const sidebarDashboardApps = (records = []) =>
  records.filter(isSidebarApp);

export const conversationDashboardApps = (records = []) =>
  records.filter(app => !isSidebarApp(app));
